module.exports = __webpack_public_path__ + "img/top-pain-1.5dec633e.svg";